import t from "react";
import { c as s, t as c } from "./useKeyDown-88662051.mjs";
import { B as i } from "./useClickOutside-55c64a80.mjs";
const l = "section", _ = "section__content", C = "block__content", b = "mobile", u = "desktop", g = "section__content__component", x = "section__content__component__title", T = "section__content__description", D = "section__content__description__footer", y = "section__content__description__body-text", E = "section__content__description__sub-heading", e = {
  section: l,
  sectionContent: _,
  blockContent: C,
  mobile: b,
  desktop: u,
  sectionContentComponent: g,
  sectionContentComponentTitle: x,
  sectionContentDescription: T,
  sectionContentDescriptionFooter: D,
  sectionContentDescriptionBodyText: y,
  sectionContentDescriptionSubHeading: E
};
function h({ content: n }) {
  return /* @__PURE__ */ t.createElement(
    "h2",
    {
      className: s(
        c.textsComponentTitleBold,
        e.sectionContentComponentTitle
      ),
      itemProp: "name"
    },
    n
  );
}
function S({ content: n }) {
  return /* @__PURE__ */ t.createElement(
    "h3",
    {
      className: s(
        c.textsParagraphSubtitleBold,
        e.sectionContentDescriptionSubHeading
      ),
      itemProp: "name"
    },
    n
  );
}
function f(n) {
  const { content: r, isFooterSection: o } = n;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s(e.sectionContentDescriptionBodyText, {
        [c.textsLeadText]: o,
        [c.richText]: o,
        [c.textsBodyText]: !o
      }),
      itemProp: "description"
    },
    r
  );
}
function P(n) {
  const { id: r, heading: o, subHeading: a, bodyText: m, isFooterSection: d } = n, p = s(
    e.sectionContentDescription,
    d ? e.sectionContentDescriptionFooter : ""
  );
  return /* @__PURE__ */ t.createElement(
    i,
    {
      as: "section",
      id: r,
      topPadding: i.Padding.SMALL,
      bottomPadding: i.Padding.LARGE,
      className: e.section,
      "data-testid": "article-section-block"
    },
    /* @__PURE__ */ t.createElement(
      i.Content,
      {
        className: e.sectionContent,
        "data-testid": "article-section-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      o && /* @__PURE__ */ t.createElement("article", { className: e.sectionContentComponent }, /* @__PURE__ */ t.createElement(h, { content: o })),
      /* @__PURE__ */ t.createElement(
        "article",
        {
          className: p,
          "data-testid": "article-section-content-description"
        },
        a && /* @__PURE__ */ t.createElement(S, { content: a }),
        /* @__PURE__ */ t.createElement(f, { isFooterSection: d, content: m })
      )
    )
  );
}
export {
  P as ArticleSection
};
//# sourceMappingURL=ArticleSection.js.map
